module.exports = __webpack_public_path__ + "static/img/tp4_7.a50811e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/banners/tp4_7.svg
// module id = S8Sy
// module chunks = 88